import { useMemo } from 'react';
import { Note } from '@mytypes/protocol';
import { parse } from 'wellknown';
import mapboxgl from 'mapbox-gl';
import Dayjs from 'dayjs';

export const useFieldNotesMarkers = (data?: Note[], popupClassName = 'fieldNotePopup') => {
  return useMemo(() => {
    if (!data) return [];

    return data
      .map((fieldNote: Note) => {
        const point = parse(fieldNote.wkt_point || '') as { type: string; coordinates: number[] } | null;
        if (!point?.coordinates) return null;

        const [longitude, latitude] = point.coordinates;
        return {
          latitude,
          longitude,
          draggable: false,
          color: 'rgb(218, 218, 218)',
          popup: new mapboxgl.Popup({ closeButton: false, closeOnClick: true, closeOnMove: false, className: popupClassName }).setHTML(`
              <div style="color:#000;">
                <div>${Dayjs(fieldNote.date).format('MM/DD/YYYY')}</div>
                <div>${fieldNote.note}</div>
              </div>
            `)
        };
      })
      .filter(Boolean);
  }, [data, popupClassName]);
};
